import React, { useMemo, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import type { ComponentProps } from 'react';
import InventoryList from './InventoryList';
import { sharedPrintStyles, basePrintContainerStyle } from './printStyles';

type InventoryPayload = ComponentProps<typeof InventoryList>;

function decodePayload(params: URLSearchParams): InventoryPayload | null {
  const payload = params.get('payload');
  if (!payload) return null;
  try {
    const decoded = atob(decodeURIComponent(payload));
    return JSON.parse(decoded) as InventoryPayload;
  } catch (err) {
    console.error('Failed to decode inventory payload', err);
    return null;
  }
}

const InventoryPrintPage: React.FC = () => {
  const [params] = useSearchParams();
  const data = useMemo(() => decodePayload(params), [params]);

  useEffect(() => {
    console.log('InventoryPrintPage mounted', { hasData: !!data });
  }, [data]);

  if (!data) {
    return (
      <div className="print-page" style={errorStyles}>
        <p>Missing or invalid print payload.</p>
      </div>
    );
  }

  return (
    <div className="print-page" style={pageStyle}>
      <style>{sharedPrintStyles}</style>
      <InventoryList {...data} />
    </div>
  );
};

const pageStyle: React.CSSProperties = {
  ...basePrintContainerStyle,
  backgroundColor: '#fff',
  minHeight: '100vh',
  padding: 0,
};

const errorStyles: React.CSSProperties = {
  ...pageStyle,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '16px',
};

export default InventoryPrintPage;


